import {combineReducers} from '@modifi/redux'

import shipmentsReducer from './shipments/reducer'

export default combineReducers({
  shipments: shipmentsReducer,
})
